/* v8 ignore start */
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {jwtDecode} from "jwt-decode";

import {TRootState} from "@/store";
import {fetchAnimatedProject} from "@/store/slices/animatedProjectSlice/thunks";

interface IPlayerState {
  token: string;
  isOwner: boolean;
  userId?: number;
  firstName?: string;
  email?: string;
}

const initialState: IPlayerState = {token: "", isOwner: false, userId: undefined};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    tokenReceived: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      const decodedToken: {user_id: string; name: Nullable<string>; email: Nullable<string>} = jwtDecode(
        action.payload
      );
      state.userId = Number(decodedToken.user_id);
      state.firstName = decodedToken.name != null ? decodedToken.name.split(" ")[0] : "";
      state.email = decodedToken.email != null ? decodedToken.email : "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAnimatedProject.fulfilled, (state, action) => {
      state.isOwner = action.payload.creatorId === state.userId;
    });
  },
});

export const {tokenReceived} = authSlice.actions;

export const tokenSelector = (state: TRootState) => state.auth.token;
export const isOwnerSelector = (state: TRootState) => state.auth.isOwner;
export const userFirstNameSelector = (state: TRootState) => state.auth.firstName;
export const userEmailSelector = (state: TRootState) => state.auth.email;

export default authSlice.reducer;
/* v8 ignore stop */
